$( document ).ready(function() 
{
   console.log("ddaadadadawwdad")
$('.lightining-newflow-collection-list .collection-list-wrap').slick({
    dots: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 4,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/><path d="M0 0h24v24H0z" fill="none"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59 7.41L13.17 12l-4.58 4.59L10 18l6-6-6-6-1.41 1.41z"/><path d="M0 0h24v24H0z" fill="none"/></svg></button>',
    responsive: [
        {
            breakpoint: 1024,
            settings: 
            {
                slidesToShow: 3,
                slidesToScroll: 3 
            }
        },
        {
            breakpoint: 768,
            settings:
            {
                slidesToShow: 3.5,
                slidesToScroll: 2
            } 
        },
        {
            breakpoint: 480,
            settings:
            {
                slidesToShow: 2.5,
                slidesToScroll: 1
            }
        }
    ]
  });
});